module.exports = __webpack_public_path__ + "img/revista-madrigal-04.996262ca.jpg";